import React, {useEffect, useState, useRef} from 'react';
import {Tabs} from 'antd';
import './ViewKeyRiskIndicator.scss';
import {t} from 'react-switch-lang';
import SelectList from '../../../components/FormFields/Select';
import TextArea from '../../../components/FormFields/Textarea';
import InputText from '../../../components/FormFields/InputText';
import InputYear from '../../../components/FormFields/inputDate/InputYear';
import {
  getKeyRisk,
  updateKeyRisk,
  deleteKeyRisk,
  deleteKeyRiskOccurrence, getPotentialRisksList, getRiskById,
} from '../../../services/keyRiskIndicatorsService';
import {getLanguage} from 'react-switch-lang';
import * as yup from 'yup';
import '../addKeyRiskIndicator/AddKeyRiskIndicator.scss';
import {useHistory} from 'react-router-dom';
import {useForm, FormProvider, useWatch} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import Toast from '../../../components/toast/Toast';
import {useUserContext} from '../../../contexts/UserContext';
import Prompt from '../../../components/prompt/prompt';
import CustomTable from '../../../components/customTable/CustomTable';
import {ReactComponent as OptionsImg} from '../img/options.svg';
import Dropdown from '../../../components/droppdown/dropdown';
import OccurrenceModal from './riskOccurrenceModal/OccurrenceModal';
import {formatDate} from '../../../utils/formatDate';
import {periods, escalationCalculationTypeOptions} from '../utils/periods';
import roles from '../../../utils/roles';
import Swal from 'sweetalert2';
import {useDepartmentContext} from '../../../contexts/DepartmentContext';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import {appModules} from '../../../utils/const';
import {yesNoOptions} from '../../../utils/externalizationFormOptions';

const {TabPane} = Tabs;

const ViewKeyRiskIndicator = (props) => {
  const lang = getLanguage();
  const prevProcessIdRef = useRef(null);
  const prevRiskDescriptionRef = useRef(null);
  const [keyRisk, setKeyRisk] = useState(null);
  let history = useHistory();
  const [isKeyIndicator, setIsKeyIndicator] = useState();
  const [potentialRiskOptions, setPotentialRiskOptions] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const userAuthorities = useUserContext().authorities;
  const userDepartments = useDepartmentContext();

  const userSuperAdmin = userAuthorities.some((r) =>
    r.includes(roles.role_super_admin)
  );
  const userRiskSector = userAuthorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );
  const userResponsible = userAuthorities.some((r) =>
    r.includes(roles.role_responsible_user)
  );
  const userInCharge = userAuthorities.some((r) =>
    r.includes(roles.role_user_in_charge)
  );

  const [departmentUserInCharge, setDepartmentUserInCharge] = useState(false);
  const [departmentUserResponsible, setDepartmentUserResponsible] = useState(false);
  const [disableSubprocess, setDisableSubprocess] = useState(true);
  const [potentialRiskPage, setPotentialRiskPage] = useState(0);
  const [hasMorePotentialRisk, setHasMorePotentialRisk] = useState(true);
  const [loadingPotentialRisk, setLoadingPotentialRisk] = useState(false);

  const schema = yup.object().shape({
    process: yup.object().nullable().required(t('message.fieldRequired')),
    subprocess: yup.object().nullable().required(t('message.fieldRequired')),
    escalationCalculationType: yup.object().nullable().required(t('message.fieldRequired')),
    potentialRiskId: yup.object().nullable().required(t('message.fieldRequired')),
    riskIndicatorNameMne: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(500, t('message.max', {max: 500})),
    escalationPointValue: yup
      .string()
      .nullable()
      .required(t('message.fieldRequired'))
      .max(4, t('message.max', {max: 4})),
    period: yup.object().nullable().required(t('message.fieldRequired')),
    escalationDescription: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(500, t('message.max', {max: 500})),
    department: yup.object().nullable().required(t('message.fieldRequired')),
    riskDescriptionMne: yup
      .string()
      .required(t('message.fieldRequired'))
      .max(2048, t('message.max', {max: 2048})),
    year: yup.string().nullable().required(t('message.fieldRequired')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, reset, setValue} = methods;
  const watchProcess = useWatch({ control: methods.control, name: 'process' });
  const processIdForSubprocess =
    watchProcess?.value ?? keyRisk?.process?.value ?? null;
  const watchPotentialRisk = useWatch({
    control: methods.control,
    name: 'potentialRiskId',
  });
  const fetchPotentialRisks = async (pageToLoad = 0, replace = false) => {
    try {
      setLoadingPotentialRisk(true);
      const {data} = await getPotentialRisksList(20, pageToLoad);

      const mappedOptions = data.map((item) => ({
        value: item.id,
        label: item.title,
      }));

      setPotentialRiskOptions(prev =>
        replace ? mappedOptions : [...prev, ...mappedOptions]
      );
      setPotentialRiskPage(pageToLoad);
      setHasMorePotentialRisk(data.length === 20);
    } catch (error) {
      setPotentialRiskOptions([]);
    } finally {
      setLoadingPotentialRisk(false);
    }
  };
  console.log(watchPotentialRisk?.value, 'watchPotentialRisk');
  useEffect(() => {
    const fillProcessSubprocessDescription = async () => {
      if (!watchPotentialRisk?.value) {
        if (keyRisk?.process) {
          setValue('process', keyRisk.process, { shouldValidate: true });
        }
        if (keyRisk?.subprocess) {
          setValue('subprocess', keyRisk.subprocess, { shouldValidate: true });
        }

        return;
      }
      try {
        const {data} = await getRiskById(watchPotentialRisk?.value);

        if (data?.processId) {
          setValue(
            'process',
            {
              value: data.processId,
              label: lang === 'eng' ? data.processNameEn : data.processName,
            },
            {shouldValidate: true, shouldDirty: true}
          );
        } else {
          setValue('process', null, {shouldValidate: false, shouldDirty: true});
        }

        if (data?.subprocessId) {
          setValue(
            'subprocess',
            {
              value: data.subprocessId,
              label: lang === 'eng' ? data.subprocessNameEn : data.subprocessName,
            },
            {shouldValidate: true, shouldDirty: true}
          );
        } else {
          setValue('subprocess', null, {shouldValidate: false, shouldDirty: true});
        }
        if(data?.description){
          setValue('riskDescriptionMne',data?.description);
        } else {
          setValue('riskDescriptionMne', null);
        }
      } catch (error) {
        setValue('process', null, {shouldValidate: false, shouldDirty: true});
        setValue('subprocess', null, {shouldValidate: false, shouldDirty: true});
        setValue('riskDescriptionMne',null);
      }
    };

    fillProcessSubprocessDescription();
  }, [watchPotentialRisk, lang, setValue]);
  useEffect(() => {
    const fetchKeyRisk = async () => {
      try {
        const {data} = await getKeyRisk(props.match.params.id);
        setIsKeyIndicator(!!data?.isKeyIndicator);
        if (userInCharge) {
          userDepartments.forEach((department) => {
            if (data.departmentId === department.id) {
              setDepartmentUserInCharge(true);
            }
          });
        }

        if (userResponsible) {
          userDepartments.forEach((department) => {
            if (data.departmentId === department.id) {
              setDepartmentUserResponsible(true);
            }
          });
        }
        let selectedPeriod = {};
        for (let period of periods) {
          if (period.value === data.indicatorPeriod) {
            selectedPeriod = period;
          }
        }
        const selectedEscalationCalculationType =
          escalationCalculationTypeOptions.find(
            (item) => item.value === data?.escalationCalculationType
          ) || null;
        const formDefaults = {
          process: {
            label: lang === 'eng' ? data.processNameEn : data.processName,
            value: data.processId,
          },
          subprocess: {
            label: lang === 'eng' ? data.subprocessNameEn : data.subprocessName,
            value: data.subprocessId,
          },
          ...data?.potentialRiskId ? {
              potentialRiskId: {
                label: data?.potentialRiskTitle,
                value: data?.potentialRiskId,
              }
            } : null,
          department: {
            label: lang === 'eng' ? data.departmentNameEn : data.departmentName,
            value: data.departmentId,
          },
          riskIndicatorNameMne: data.indicatorName,
          riskIndicatorNameEn: data.indicatorNameEn,
          subprocessDescriptionMne: data.subprocessDescription,
          subprocessDescriptionEn: data.subprocessDescriptionEn,
          description: data.description,
          indicatorName: data.riskIndicatorName,
          indicatorNameEn: data.riskIndicatorNameEn,
          indicatorPeriod: selectedPeriod,
          measuresDescription: data.measures,
          measuresDescriptionEn: data.measuresEn,
          minValue: data.minValue,
          riskDescription: data.riskDescription,
          riskDescriptionEn: data.riskDescriptionEn,
          year:  data?.year ? new Date(Number(data?.year), 0, 1) : null,
          escalationCalculationType: selectedEscalationCalculationType,
          isKeyIndicator: data?.isKeyIndicator
        }
        setKeyRisk(formDefaults);
        reset(formDefaults);
      } catch (err) {
        if (
          err.response.data.status === 403 ||
          err.response.data.status === 404
        ) {
          history.push('/key-risk-indicators');
        }
      }
    };
    fetchKeyRisk()
  }, []);
  useEffect(() => {
    if (window.location.pathname.includes('edit')) {
      setDisableSubprocess(false);
    }
    window.location.pathname.includes('edit')
      ? setIsEditing(true)
      : setIsEditing(false);
  }, []);

  const goToAdd = () => {
    history.push({
      pathname: '/key-risk-indicators/add',
      state: {keyRisk: keyRisk},
    });
  };

  const onSubmit = async (e) => {
    const date = new Date(e.year);
    const year = date.getFullYear();
    const body = {
      id: props.match.params.id,
      departmentId: e.department['value'],
      departmentName: lang === 'mne' ? e.department['label'] : '',
      description: e.escalationDescription,
      indicatorName: e.riskIndicatorNameMne,
      indicatorPeriod: e.period['value'],
      minValue: e.escalationPointValue,
      potentialRiskId: e?.potentialRiskId.value,
      processId: e.process['value'],
      processName: lang === 'mne' ? e.process['label'] : '',
      processNameEn: lang === 'eng' ? e.process['label'] : '',
      riskDescription: e.riskDescriptionMne,
      subprocessId: e.subprocess['value'],
      subprocessName: lang === 'mne' ? e.subprocess['label'] : '',
      subprocessNameEn: lang === 'eng' ? e.subprocess['label'] : '',
      year: year,
      isKeyIndicator: isKeyIndicator,
      escalationCalculationType: e?.escalationCalculationType?.value
    };
    try {
      const response = await updateKeyRisk(body);
      if (response.status === 200) {
        await Toast.fire({
          title: t('Pages.messages.updateSuccess', {
            entity: t('Pages.common.keyRiskIndicator'),
          }),
          icon: 'success',
        });
        window.location = `/key-risk-indicators/${parseInt(response.data.id)}`;
      }
    } catch (err) {
      if (err.response.data.code === 'indicator-exists') {
        Toast.fire({
          title:
            lang === 'eng'
              ? err.response.data.description
              : t('Pages.messages.sameIndicatorAdded'),
          icon: 'error',
        });
        document.getElementById('riskIndicatorNameMne').focus();
        document.getElementById('riskIndicatorNameMne').select();
      } else {
        reset();
        setValue('escalationPointValue', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('potentialRiskId', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('process', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('subprocess', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('department', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('period', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('year', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        Swal.fire({
          text: t('Pages.messages.addError', {
            entity: lang === 'eng' ? 'key risk' : 'ključnog rizika',
          }),
          icon: 'error',
        });
      }
    }
  };

  const onDeleteKeyRisk = () => {
    const dropdown = document.getElementById('dropdown');
    const dropdownUl = document.getElementsByClassName('show')[1];
    dropdown.style.display = 'none';
    dropdownUl.style.display = 'none';

    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteKeyRisk'),
        text: t('question.delete', {
          entity: t('Pages.common.keyRiskIndicator2'),
        }),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        onClose: () => {
          dropdown.style.display = 'block';
          dropdownUl.style.display = 'block';
        },
        preConfirm: async () => {
          dropdown.style.display = 'block';
          dropdownUl.style.display = 'block';
          try {
            const response = await deleteKeyRisk(props.match.params.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('Pages.messages.deleteSuccess', {
                  entity: t('Pages.common.keyRiskIndicator'),
                }),
                icon: 'success',
              });
              resolve(response);
              history.push({
                pathname: '/key-risk-indicators',
              });
            } else {
              reject(response);
            }
          } catch (err) {
            if (err?.response?.data?.code === 'key_indicator_deletion_blocked_by_open_risks') {
              Toast.fire({
                title:t('message.keyIndicatorDeletionBlockedBOpenRisks'),
                icon: 'error',
              })
            } else {
              Swal.fire({
                text: t('Pages.messages.deleteError', {
                  entity:
                    lang === 'eng'
                      ? t('Pages.common.keyRiskIndicator2')
                      : t('Pages.common.keyRiskIndicator3'),
                }),
                icon: 'error',
              });
            }
          }
        },
      });
    });
  };

  /*** Second Tab ***/
  const columns = [
    {
      key: 'fullName',
      title: t('Pages.ViewKeyRiskIndicator.user'),
      editable: false,
      placeholder: t(''),
      render: (request) => `${request.userFirstName} ${request.userLastName}`,
    },
    {
      dataIndex: 'dateCreated',
      title: t('Pages.ViewKeyRiskIndicator.dateCreated'),
      editable: false,
      render: (value) => {
        return formatDate(value);
      },
      placeholder: t(''),
    },
    {
      dataIndex:  'description',
      title: t('Pages.ViewKeyRiskIndicator.description'),
      editable: false,
      placeholder: t(''),
    },
    {
      dataIndex: 'dateOfOccurrence',
      title: t('Pages.ViewKeyRiskIndicator.dateOfOccurrence'),
      editable: false,
      render: (value) => {
        return formatDate(value);
      },
      placeholder: t(''),
    },
    {
      dataIndex:  'harmfulEventId',
      title: t('Pages.KeyRiskIndicators.methodEventRecorded'),
      editable: false,
      placeholder: t(''),
      render: (value, record) => {
        if (value) {
          return (
            <a href={`/incurred-risk/${value}`}>
              {t("sidebar.incurred-risk")}
            </a>
          );
        }
        return `${record?.userFirstName || ''} ${record?.userLastName || ''}`.trim();
      },
    },
  ];

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteKeyRiskOccurrence'),
        text: t('question.delete', {
          entity: t('Pages.ViewKeyRiskIndicator.riskOccurrence'),
        }),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteKeyRiskOccurrence(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('Pages.messages.deleteSuccess2', {
                  entity: t('Pages.common.keyRiskIndicatorOccurrence'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError', {
                entity: t('Pages.common.keyRiskIndicatorOccurrence'),
              }),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const actionsOpenModal = {
    editTooltip: 'Pages.KeyRiskIndicators.editKeyRiskIndicator',
    deleteTooltip: 'Pages.KeyRiskIndicators.deleteKeyRiskIndicator',
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateTable, setUpdateTable] = useState(false);
  const [tableRowId, setTableRowId] = useState('');

  const closeModal = () => {
    setIsModalOpen(false);
    setUpdateTable(false);
  };

  const editKeyRiskOccurrence = (id) => {
    setTableRowId(id);
    setIsModalOpen(true);
  };

  const edit = () => {
    window.location = window.location.href + '/edit';
  };

  const back = () => {
    props.history.goBack();
  };
  useEffect(() => {
    // if(watchPotentialRisk?.value){
      fetchPotentialRisks(0, true)
    // }
    }, [watchPotentialRisk])
  const handlePotentialRiskLoadMore = () => {
    if (hasMorePotentialRisk && !loadingPotentialRisk) {
      fetchPotentialRisks(potentialRiskPage + 1, false);
    }
  };

  return (
    <div className="administration-template content">
      <Tabs defaultActiveKey="1" tabBarStyle={{color: '#37393c'}}>
        <TabPane
          tab={t('Pages.ViewKeyRiskIndicator.tab1').toUpperCase()}
          key="1"
        >
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}
                  onKeyDown={(e) => {
                    if (e?.key === 'Enter') {
                      const tag = e?.target?.tagName?.toLowerCase();
                      if (tag === 'textarea') return;
                      e.preventDefault();
                      if (isEditing) handleSubmit(onSubmit)();
                    }
                  }}>
              {userRiskSector || userSuperAdmin ? (
                <div className="container-fluid controls d-flex align-items-center justify-content-end">
                  <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                      {!isEditing ? (
                        <div className="d-flex">
                          <button
                            className="primary-btn mr-3"
                            onClick={(event) => {
                              event.preventDefault();
                              edit();
                            }}
                          >
                            {t('common.edit')}
                          </button>

                          <Dropdown
                            buttonClass="options-btn"
                            trigger={<OptionsImg />}
                            children={
                              <span id="dropdown">
                                <li
                                  onClick={(e) => {
                                    e.preventDefault();
                                    goToAdd();
                                  }}
                                >
                                  {t('common.copy')}
                                </li>
                                <li
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onDeleteKeyRisk();
                                  }}
                                >
                                  {t('common.delete')}
                                </li>
                              </span>
                            }
                          ></Dropdown>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="container-fluid pt-4">
                <div className="row" key={isEditing}>
                  <div className="col-md-4 col-xl-3">
                    <div className="title mb-3">
                      {t('Pages.AddKeyRiskIndicator.indicators')}
                    </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="riskIndicatorNameMne">
                        {t('Pages.AddKeyRiskIndicator.keyRiskNameMne')}
                      </label>
                      <InputText
                        name="riskIndicatorNameMne"
                        disabled={!isEditing}
                        id="riskIndicatorNameMne"
                        defaultValue={keyRisk?.riskIndicatorNameMne}
                        className="form-control"
                      />
                    </div>
                    <label className="label">
                      <input
                        name={"isKeyIndicator"}
                        disabled={!isEditing}
                        className='mr-5 mt-1'
                        type="checkbox"
                        id={`checkbox-single`}
                        checked={isKeyIndicator}
                        defaultValue={
                          typeof keyRisk?.isKeyIndicator === 'boolean'
                            ? yesNoOptions.find(opt => opt.value === keyRisk?.isKeyIndicator)
                            : null
                        }
                        onChange={(e) => setIsKeyIndicator(e.target.checked)}
                      />
                      <span className="pl-2">{t("Pages.KeyRiskIndicators.isKeyIndicator")}</span>
                    </label>
                  </div>
                  <div className="col-md-4 col-xl-3">
                    <div className="title mb-3">
                        {t('incurred-risk.potentionalRisk')}
                      </div>
                      <label className="label">
                        {t('incurred-risk.potentionalRisk')}
                      </label>
                      <div className="form-group mb-4">
                        <SelectList
                          name="potentialRiskId"
                          options={potentialRiskOptions}
                          className="select"
                          placeholder={t('incurred-risk.placeholder.potentionalRisk')}
                          isClearable={true}
                          isDisabled={!isEditing}
                          showValueInLabel={true}
                          // defaultValue={keyRisk?.potentialRiskId}
                          onLoadMore={handlePotentialRiskLoadMore}
                          hasMore={hasMorePotentialRisk}
                          isLoading={loadingPotentialRisk}

                        />
                      </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="riskDescriptionMne">
                        {t('Pages.AddKeyRiskIndicator.riskDescMne')}
                      </label>
                      <TextArea
                        name="riskDescriptionMne"
                        defaultValue={keyRisk?.riskDescription}
                        disabled={true}
                        ref={prevRiskDescriptionRef}
                      />
                    </div>
                    <div className="title mb-3">
                        {t('Pages.AddKeyRiskIndicator.processesAndSubprocesses')}
                      </div>
                      <label className="label" htmlFor="process">
                        {t('Pages.AddKeyRiskIndicator.processes')}
                      </label>
                      <SelectInfinite
                        api="processes?active.equals=true"
                        name="process"
                        ref={prevProcessIdRef}
                        // defaultValue={
                        //   keyRisk?.process !== undefined ? keyRisk?.process : ''
                        // }
                        placeholder={t('litigation.placeholder.process')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                      />
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="subprocess">
                        {t('Pages.AddKeyRiskIndicator.subprocesses')}
                      </label>
                      <SelectInfinite
                        api={
                          processIdForSubprocess
                            ? `/subprocesses?processId.equals=${processIdForSubprocess}&active.equals=true`
                            : `/subprocesses?processId.equals=1&active.equals=true`
                        }
                        name="subprocess"
                        placeholder={t('common.select')}
                        key={processIdForSubprocess}
                        className="select"
                        // defaultValue={
                        //   keyRisk?.subprocess !== undefined
                        //     ? keyRisk?.subprocess
                        //     : ''
                        // }
                        isDisabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-xl-3">
                    <div className="title mb-3">
                      {t('Pages.AddKeyRiskIndicator.escalation')}
                    </div>
                    <label className='label w-100 mt-2'>
                      {t('Pages.KeyRiskIndicators.escalationCalculationType')}
                    </label>
                    <SelectList
                      name="escalationCalculationType"
                      className="select pb-4"
                      options={escalationCalculationTypeOptions}
                      placeholder={t('Pages.KeyRiskIndicators.placeholder.escalationCalculationType')}
                      isClearable={true}
                      isDisabled={!isEditing}
                      defaultValue={keyRisk?.escalationCalculationType}
                    />
                    <div className="row mb-4 d-flex flex-md-column flex-lg-row">
                      <div className="col-md-12 col-lg-6">
                        <label className="label" htmlFor="escalationPointValue">
                          {t('Pages.AddKeyRiskIndicator.escalationPointValue')}
                        </label>
                        <InputText
                          name="escalationPointValue"
                          disabled={!isEditing}
                          type="number"
                          defaultValue={keyRisk?.minValue}
                          className="form-control"
                        />
                      </div>
                      <div className="col-md-12 col-lg-6">
                        <label className="label" htmlFor="period">
                          {t('Pages.AddKeyRiskIndicator.escalationPointPeriod')}
                        </label>
                        <SelectList
                          name="period"
                          options={periods}
                          key={keyRisk?.indicatorPeriod}
                          selected={keyRisk?.indicatorPeriod}
                          isDisabled={!isEditing}
                          placeholder={t('common.select')}
                        />
                      </div>
                    </div>
                    <div className="form-group mb-4">
                      <label className="label" htmlFor="escalationDescription">
                        {t('Pages.AddKeyRiskIndicator.escalationPointDesc')}
                      </label>
                      <TextArea
                        name="escalationDescription"
                        defaultValue={keyRisk?.description}
                        disabled={!isEditing}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-xl-3">
                    <div className="form-group mb-4">
                      <div className="title mb-3">
                        {t('Pages.AddKeyRiskIndicator.organization')}
                      </div>
                      <label className="label" htmlFor="department">
                        {t('Pages.AddKeyRiskIndicator.department')}
                      </label>
                      <SelectInfinite
                        api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                        name="department"
                        placeholder={t('common.select')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        defaultValue={keyRisk?.department}
                        key={keyRisk?.department}
                        isDisabled={!isEditing}
                      />
                    </div>
                    <div className="title mb-3">
                      {t('Pages.AddKeyRiskIndicator.year')}
                    </div>
                    <div className="form-group d-flex flex-column">
                      <label className="label" htmlFor="year">
                        {t('Pages.AddKeyRiskIndicator.year')}
                      </label>
                      <InputYear
                        name="year"
                        defaultValue={keyRisk?.year}
                        key={keyRisk?.year}
                        disabled={!isEditing}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {isEditing ? (
                <div className="container-fluid mt-4 footer">
                  <div className="row">
                    <div className="col-12 pt-4 pb-4 d-flex justify-content-end footer">
                      <button
                        className="secondary-btn"
                        onClick={(event) => {
                          event.preventDefault();
                          back();
                        }}
                      >
                        {t('common.cancel')}
                      </button>
                      <button type="submit" className="primary-btn">
                        {t('common.save')}
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
            </form>
          </FormProvider>
        </TabPane>
        <TabPane
          tab={t('Pages.ViewKeyRiskIndicator.tab2').toUpperCase()}
          key="2"
        >
          {userSuperAdmin ||
          departmentUserInCharge ||
          departmentUserResponsible ||
            userRiskSector ? (
            <div className="container-fluid controls d-flex align-items-center justify-content-end">
              <div className="row">
                <div className="col-12 d-flex justify-content-end">
                  <div>
                    <button
                      className="primary-btn pl-4 pr-4"
                      onClick={(event) => {
                        event.preventDefault();
                        setIsModalOpen(true);
                        setTableRowId('');
                      }}
                    >
                      {t('common.add')}
                    </button>
                    <OccurrenceModal
                      key={isModalOpen}
                      keyId={props.match.params.id}
                      tableRowId={tableRowId}
                      title={
                        tableRowId
                          ? t('Pages.ViewKeyRiskIndicator.edit')
                          : t('Pages.ViewKeyRiskIndicator.add')
                      }
                      isOpen={isModalOpen}
                      isClosed={closeModal}
                      escPressed={() => {
                        closeModal();
                      }}
                      updateTable={() => {
                        setUpdateTable(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <CustomTable
            api={'key-indicator-occurs'}
            query={`${props.match.params.id}`}
            queryParamName="keyIndicatorId.equals"
            columns={columns}
            actionsOpenModal={actionsOpenModal}
            onColumnEdit={editKeyRiskOccurrence}
            updateTable={updateTable}
            key={updateTable}
            methods={{onDelete}}
            actionsWidth={'100px'}
            roles={{
              userSuperAdmin: userSuperAdmin,
              userRiskSector: userRiskSector,
              userInCharge: departmentUserInCharge,
              userResponsible: departmentUserResponsible,
            }}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};
export default ViewKeyRiskIndicator;
